<div class="flex justify-center items-center w-full">
    <form class="py-10 w-full max-w-full mx-auto px-4">

        <div class="flex flex-wrap lg:flex-nowrap justify-center gap-x-6 gap-y-4">

            <div class="w-full md:w-1/3 lg:w-1/4">
                <mat-form-field class="w-full min-w-[250px] max-w-[350px]">
                    <mat-label>k value</mat-label>
                    <input matInput placeholder="k value"  autocomplete="off">
                </mat-form-field>
            </div>
    
            <div class="w-full md:w-1/3 lg:w-1/4">
                <mat-form-field class="w-full min-w-[250px] max-w-[350px]">
                    <mat-label>M<sub>1</sub></mat-label>     
                    <input matInput autocomplete="off">
                </mat-form-field>
            </div>
     
            <div class="w-full md:w-1/3 lg:w-1/4">
                <mat-form-field class="w-full min-w-[250px] max-w-[350px]">
                    <mat-label>Deflection angle (δ) (weak shock)</mat-label>     
                    <input matInput  autocomplete="off">
                </mat-form-field>
            </div>
        </div>    
    
        <!-- Center the button below the fields -->
        <div class="flex justify-center mt-6">
            <button mat-raised-button type="submit">
                Calculate
            </button>
        </div>


    </form>


</div>